import React from 'react';

import { useFormContext } from 'react-hook-form';
import { InputAdornment } from '@infoods/lifebase-ui';

import {
  LbNumericFormatInput,
  ModeAwareInput,
} from '../../../../../shared/components/form-components';
import { Nutrient } from '../../../../../shared/components/ui-components';
import {
  FoodFormNutrient,
  NUTRIENT_ROUNDING_PRECISION,
} from '../../constants/foodFormNutrients';
import { FoodFormValues } from '../../interfaces/FoodFormValues';
import { processMeasurement } from '../../../../../shared/utils/mealUtils';
import { Mode } from '../../../../../general-types';

type NutrientInputProps = {
  mode: Mode;
  nutrient: FoodFormNutrient;
  /** used in the error copy too */
  name: string;
  max: number;
};

const NutrientInput = ({ mode, nutrient, name, max }: NutrientInputProps) => {
  const { control } = useFormContext<FoodFormValues>();
  const rangeMessage = `Value should be between 0 and ${max}`;
  const unit = processMeasurement(nutrient);

  return (
    <ModeAwareInput
      control={control}
      name={`nutrients.${nutrient}`}
      label={`${name} (${unit})`}
      mode={mode}
      size="medium"
      renderValue={(value) => <Nutrient nutrient={nutrient}> {value}</Nutrient>}
      renderEdit={(props) => (
        <LbNumericFormatInput
          {...props}
          rules={{
            required: `${name} is required`,
            min: { value: 0, message: rangeMessage },
            max: { value: max, message: rangeMessage },
          }}
          allowNegative={false}
          decimalScale={NUTRIENT_ROUNDING_PRECISION}
          selectValueOnFocus
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Nutrient nutrient={nutrient} />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
};

export { NutrientInput };
